import { AxiosResponse } from "axios";
import { api, authApi } from "../instances";
import { confirmOrderReq, confirmOrderRes, getFiliaslRes, GetScheduleReq, GetScheduleRes, GetUsiDocsReq, GetUsiDocsRes, NotificationTokenReq, NotificationTokenRes } from "../../types/api/utils.api.types";
import { AnalysisGetReq, AnalysisGetRes } from "../../types/api/analysis.api.types";
import { UTILS_PATHS } from "../paths/index.paths";
import { ConvertDataToGetParams } from "../../utils/ConvertDataToGetParams";


export class UtilsApi {
    static async SendNotificationToken(req: NotificationTokenReq): Promise<AxiosResponse<NotificationTokenRes>> {
        const res: AxiosResponse<NotificationTokenRes> = await api.post(UTILS_PATHS.PUSH_NOTIF_TOKEN, req);
        return res;
    }
    
    static async GetFilials(req: {"type": number}): Promise<AxiosResponse<getFiliaslRes>> {
        const res: AxiosResponse<getFiliaslRes> = await api.get(`${UTILS_PATHS.GET_FILIALS}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async GetUsiDocs(req: GetUsiDocsReq): Promise<AxiosResponse<GetUsiDocsRes>> {
        const res: AxiosResponse<GetUsiDocsRes> = await api.get(`${UTILS_PATHS.GET_USI_DOCS}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async GetSchedule(req: GetScheduleReq): Promise<AxiosResponse<GetScheduleRes>> {
        const res: AxiosResponse<GetScheduleRes> = await api.get(`${UTILS_PATHS.GET_SCHEDULE}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async GetAllProducts(): Promise<AxiosResponse<AnalysisGetRes>> {
        const res: AxiosResponse<AnalysisGetRes> = await api.get(UTILS_PATHS.GET_ALL_PRODUCTS);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async ConfirmOrder(req: confirmOrderReq): Promise<AxiosResponse<confirmOrderRes>> {
        const res: AxiosResponse<confirmOrderRes> = await api.post(UTILS_PATHS.CONFIRM_ORDER);
        return res
    }

}